/* eslint @typescript-eslint/no-explicit-any: 0 */
import de from "./de.json"
import en from "./en.json"
import fr from "./fr.json"

const translations = { en, de, fr } as const

type TranslationKeys = DotNestedKeys<(typeof translations)["en"]>

export type Language = keyof typeof translations

export const getTranslation = (language: Language, key: TranslationKeys): string => {
  const keys = key.split(".")
  let translation: any = translations[language]

  for (const k of keys) {
    if (translation[k] === undefined) {
      return key // Return the key if the translation is not found
    }
    translation = translation[k]
  }

  return translation
}

type DotPrefix<T extends string> = T extends "" ? "" : `.${T}`

type DotNestedKeys<T> = (
  T extends object ? { [K in keyof T]: `${K & string}${DotPrefix<DotNestedKeys<T[K]>>}` }[keyof T] : ""
) extends infer D
  ? Extract<D, string>
  : never
